import { render, staticRenderFns } from "./CardHeaderFromProps.vue?vue&type=template&id=4cac6145"
import script from "./CardHeaderFromProps.vue?vue&type=script&lang=js"
export * from "./CardHeaderFromProps.vue?vue&type=script&lang=js"
import style0 from "./CardHeaderFromProps.vue?vue&type=style&index=0&id=4cac6145&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports